module.exports = __webpack_public_path__ + "img/as-apps.1c03b472.jpg";